import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { ChangeOrderStatusAPI } from "../../../../Redux/orders";
import { useLocation, useParams } from "react-router-dom";
import { BtnLoader } from "../../../../../Components/Components";

const PlaningStatusErrorModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<any>>;
  title: any;
  description: any;
  setSearchParams: any;
  handleRedirect: any;
  buttonText?: string;
}> = ({
  visible,
  setIsModalVisible,
  title,
  description,
  setSearchParams,
  handleRedirect,
  buttonText,
}) => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const onClose = () => {
    setIsModalVisible(null);
  };
  const handleSave = () => {
    handleRedirect();
  };

  return (
    <Modal
      title={<div className="text-center fs-4 fw-bolder lh-m">{title}</div>}
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-126"
            onClick={handleSave}
          >
            {buttonText || "UPDATE"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
          {description}
        </p>
      </div>
    </Modal>
  );
};

export default PlaningStatusErrorModal;
